<app-dialog-overlay (closed)="closeDialog()">
  <div class="ui-dialog-card">

  <p class="ui-page-subtitle mb-5">{{ "copy_to_clipboard.copy_title" | translate }}</p>

  <div class="border p-3 mt-2.5 rounded bg-gray-100 share-message" contenteditable="true">
    {{ messageComplete }}
  </div>

  <div class="mt-2.5">
    <app-button (click)="copyToClipboard()">
      <p>{{ "copy_to_clipboard.copy-to-clipboard" | translate }}</p>
    </app-button>
  </div>


        <!--<div class="row">
          <div class="d-flex justify-content-between p-0">
            <div
              class="flex-grow-1 m-1"
              *ngFor="let buttonConfig of data?.buttonsConfig"
            >
              <app-button
                [color]="buttonConfig?.color ?? 'primary'"
                (click)="closeDialog(buttonConfig.action, buttonConfig?.callback)"
              >
                <span class="font-text-small">{{
                  buttonConfig.translation | translate
                }}</span>
              </app-button>
            </div>
          </div>
        </div>-->
  </div>
</app-dialog-overlay>
